import { useMutation } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type {
  AddQuoteFilesToComponentQueryVars,
  ComponentData,
  MutationFunction,
} from '@frontend/api';

export const getAddQuoteFilesAsComponentsKey = () =>
  ['quotes', 'quoteFiles', 'addAsComponents'] as const;

export const useAddQuoteFilesAsComponents: MutationFunction<
  ComponentData,
  AddQuoteFilesToComponentQueryVars
> = ({ requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation({
    mutationFn: ({ quoteId, ...body }) =>
      request(`/quotes/${quoteId}/merge_quote_files_as_components`, {
        init: { method: 'POST', body },
      }),
    ...queryOptions,
    mutationKey: getAddQuoteFilesAsComponentsKey(),
  });
};
